export const NEW_ALERTS = "home.activation.new.alerts";
